// These types must be kept in sync with the OrganisationRelationshipType enum in the backend
export const REPORTS_TO_NATIONAL = "REPORTS_TO_NATIONAL";
export const REPORTS_TO_STATE = "REPORTS_TO_STATE";
export const REPORTS_TO_REGIONAL = "REPORTS_TO_REGIONAL";
export const MANAGES_NATIONAL = "MANAGES_NATIONAL";
export const MANAGES_STATE = "MANAGES_STATE";
export const MANAGES_REGIONAL = "MANAGES_REGIONAL";
export const PROVIDES_SOFTWARE_FOR = "PROVIDES_SOFTWARE_FOR";
export const USES_SOFTWARE_PROVIDED_BY = "USES_SOFTWARE_PROVIDED_BY";